import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'

type DeleteCommentResponse = paths['/api/carts/multi-carts/{multiCartId}/comments/{commentId}']['delete']['responses']['200']['content']['application/json']

export async function deleteMultiCartComment(
  multiCartId: string,
  commentId: string,
): Promise<void> {
  await request.delete<DeleteCommentResponse>(
    `/api/carts/multi-carts/${multiCartId}/comments/${commentId}`,
    { credentials: 'include' },
  )
}
